/*jslint white: true, nomen: true */
/*global angular */
(function() {
  'use strict';

  angular.module('app.forms')
    .directive('formComponentFormResults', [function() {
      return {
        restrict: 'E',
        templateUrl: 'form-component-form-results',
        replace: true,
        scope: {
          formResult: "="
        },
        bindToController: true,
        controllerAs: 'vm',
        link: function() {},
        controller: [function() {}]
      };

    }]);
}());